import {
  Button,
  type ButtonProps,
  type MantineSize,
  Tooltip,
} from "@mantine/core";
import type React from "react";
import { Link } from "react-router";

interface IGradientButtonProps {
  label: string | React.ReactNode;
  href?: string;
  target?: string;
  disabled?: boolean;
  isFullWidth?: boolean;
  className?: string;
  classNames?: ButtonProps["classNames"];
  onClick?: () => void;
  size?: MantineSize;
  isGradient?: boolean;
  isLoading?: boolean;
  tooltip?: string;
}

const Gradient: React.FC<IGradientButtonProps> = ({
  label,
  href,
  target,
  disabled = false,
  isFullWidth = false,
  className = "",
  onClick = () => {},
  size = "sm",
  isGradient = true,
  isLoading = false,
  classNames,
  tooltip,
}) => {
  const variants = {
    gradient: "gradient-blue-purple",
    default:
      " text-primary-white bg-primary-darker hover:text-primary-white hover:bg-primary-default active:text-primary-white active:bg-primary-darker border-none disabled:text-primary-white disabled:bg-primary-light",
    disabled: " text-primary-dark-text/50 bg-primary-default border-none",
  };

  let options = undefined;

  if (href) {
    options = {
      component: Link,
      to: href,
      target,
    };
  }

  const ButtonComp = (
    <Button
      className={`${
        variants[disabled ? "disabled" : isGradient ? "gradient" : "default"]
      } font-inter font-semibold ${className}`}
      classNames={classNames}
      disabled={disabled}
      fullWidth={isFullWidth}
      size={size}
      variant={isGradient ? "gradient" : "default"}
      onClick={() => (href ? null : onClick())}
      loading={isLoading}
      {...(options as object)}
    >
      {label}
    </Button>
  );

  if (tooltip) {
    return (
      <Tooltip label={tooltip} position="top" withArrow>
        {ButtonComp}
      </Tooltip>
    );
  }

  return <>{ButtonComp}</>;
};

export default Gradient;
